import styled from "styled-components";
import Footer from "./Footer";
import HeroSection from "./HeroSection";
import AnimatedPageVertical from "../../loggedIn/AnimatedPageVertical";
import WhyChooseUs from "./WhyChooseUs";
import PricingSection from "./pricing/PricingSection";
import AboutUs from "./AboutUs";
import ContactUs from "./ContactUs";
import scrollToSection from "../../../../controllers/scrollToSection";

const PageWrapper = styled.div`
  font-family: "Inter", sans-serif;
  background: #fff;
  color: #000000;
  min-height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 900px) {
    padding: 0;
    align-items: center;
  }
`;

const WideContainer = styled.div`
  width: 90vw;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 900px) {
    margin: 0;
    width: 95vw;
  }
`;

/* Navbar */

const FullLogo = styled.img`
  height: 55px;
`;
const Navbar = styled.nav`
  width: 92%;
  padding: 0;
  margin-top: 60px;
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 768px) {
    display: none;
  }
`;

const MobileLogo = styled.img`
  display: none;
  height: 45px;
  margin-top: 30px;

  @media (max-width: 900px) {
    display: block;
    margin-bottom: 30px;
  }
`;

const NavLinks = styled.div`
  display: flex;
  list-style: none;
  gap: 50px;
`;
const NavLink = styled.div`
  cursor: pointer;
  font-size: 16px;
  font-weight: 650;
  color: #111;
  &:hover {
    text-decoration: underline;
  }
`;

export default function LandingPage() {
  return (
    <AnimatedPageVertical>
      <PageWrapper>
        <HeroSection />
        <WideContainer>
          {/* <WhyChooseUs /> */}
          {/* <PricingSection /> */}
          <AboutUs />
          <ContactUs />
        </WideContainer>

        <Footer />
      </PageWrapper>
    </AnimatedPageVertical>
  );
}
